<template>
  <div class="homepage-admin-hub-container">
    <settings-content
        :navigation="navigation"
    ></settings-content>

  </div>
</template>
<script>
import SettingsContent from '@/views/homepage-settings/components/SettingsContent'
const scrollActiveItemClass = '.scrollactive-item'
const activeSectionClass = '.active-section'
export default {
    components: {
    SettingsContent
  },
  props: {
    section: {
      type: String
    },
    subsection: {
      type: String
    }
  },
  computed: {
      navigation () {
        return {
          section: this.section,
          subsection: this.subsection
        }
    }
  },
  methods: {
      setFirstSubsectionActive () {
          this.$nextTick(() => {
            let elements = document.querySelectorAll(scrollActiveItemClass)
            for (let i = 0; i < elements.length; i++) {
              elements[i].classList.remove(this.activeScroll.activeClass)
            }
            let el = document.querySelector(
              `${activeSectionClass} ${scrollActiveItemClass}`
            )
            el && el.classList.add(this.activeScroll.activeClass)
          })
      }
  }
}
</script>
<style lang="scss">
  .homepage-admin-hub-container {
    max-width: 1185px !important;
    margin: 0 auto !important;
    display: flex;
    width: 100%;
    // overflow: hidden;
    position: relative;
  }
</style>
